import React from "react";
import AssessmentLauncher from "../AssessmentLauncher/AssessmentLauncher";

export default class LearningPlanExam extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible:
        typeof this.props.visible !== "undefined" ? this.props.visible : false,
    };
  }

  render() {
    const {
      get_assessment_path,
      assessment_respond_path,
      user_assessment,
      learning_plan_item,
    } = this.props;
    const { learnable = {}, posttest_passing_score } = learning_plan_item;
    const { passing_score } = learnable;
    const { data = {}, locked = false } = user_assessment;
    const { type: template_type } = data;
    const name = learnable.name
      ? learnable.name
      : I18n.t(template_type.toLowerCase());

    return (
      <div className="learning-plan-exam">
        <div className="bordered-heading">
          <h1>{name}</h1>
        </div>
        <div
          style={{
            border: "1px solid rgba(0, 0, 0, 0.125)",
            padding: "2rem",
            borderRadius: "0.25rem",
            marginBottom: "1rem",
          }}
        >
          {locked ? (
            <div className="text-center">
              <div style={{ marginBottom: "1rem", color: "#AFAFAF" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="44"
                  height="44"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
                </svg>
              </div>
              <span>{`${name} is locked. Please contact `}</span>
              <a href="mailto:honoryourfuture@ho-chunk.com">honoryourfuture@ho-chunk.com</a>
              <span> to unlock it.</span>
            </div>
          ) : (
            <div>
              <p
                className="text-center"
                style={{
                  maxWidth: "488px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {this.getExamHelperText(
                  template_type,
                  name,
                  passing_score || posttest_passing_score
                )}
              </p>
              <AssessmentLauncher
                assessment_respond_path={assessment_respond_path}
                user_assessment={user_assessment}
                display_mode="fullscreen"
                visible={this.state.visible}
                get_assessment_path={get_assessment_path}
                buttonTitle={this.getButtonTitle(template_type)}
                success_page={this.getSuccessPage(template_type)}
                course={this.props.course}
                onHide={() => {
                  if (
                    template_type === "SUMMARY" ||
                    template_type === "POST_CONTENT"
                  ) {
                    window.location.href = this.props.course_catalog_path;
                  } else {
                    location.reload();
                  }
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  getButtonTitle(template_type) {
    if (template_type == "PRE_CONTENT") {
      return I18n.t("take_pretest");
    } else if (template_type == "POST_CONTENT") {
      return I18n.t("take_posttest");
    } else {
      return I18n.t("take_exam");
    }
  }

  getExamHelperText(template_type, name, passing_score) {
    if (template_type == "PRE_CONTENT") {
      return I18n.t("pretest_helper_text");
    } else if (template_type == "POST_CONTENT") {
      if (typeof passing_score !== "undefined") {
        return (
          I18n.t("score_needed_to_pass", {
            score: passing_score,
            name: I18n.t("posttest").toLowerCase(),
          }) +
          " " +
          I18n.t("posttest_helper_text")
        );
      } else {
        return I18n.t("posttest_helper_text");
      }
    } else {
      if (typeof passing_score !== "undefined") {
        return (
          I18n.t("score_needed_to_pass", { score: passing_score, name: name }) +
          " " +
          I18n.t("exam_helper_text", { name: name })
        );
      } else {
        return I18n.t("exam_helper_text", { name: name });
      }
    }
  }

  getSuccessPage(template_type) {
    if (template_type == "PRE_CONTENT") {
      return "LearningPlanExamSuccessPreTest";
    } else if (template_type == "POST_CONTENT") {
      return "LearningPlanExamSuccessPostTest";
    } else {
      return "LearningPlanExamSuccessScoreUnreleased";
    }
  }
}
